<div class="container">
  <pdq-media-card
    [imageUrl]="logoUrl"
    [inactive]="disabled"
    [clickable]="!disabled"
    [id]="integration?.type?.name"
    (onClick)="handleIntegrationClick($event)">
    <div class="content">
      <p class="title" [ngClass]="{ disabled: disabled }">
        {{ integration?.type?.displayName }}
      </p>
      <p class="description" [ngClass]="{ disabled: disabled }">
        {{ description || '' }}
      </p>
      @if (integration?.instance?.isConnected) {
        <pdq-tag size="small" mode="rect" variant="quaternary" value="Connected"></pdq-tag>
      }</div
  ></pdq-media-card>
</div>
